import { useDownloadFromUrl } from '@modules/file-menagement';
import { Button, Tooltip, styled } from '@mui/material';
import { CircularProgressWithLabel } from 'src/components/CircularProgressWithLabel';
import Iconify from 'src/components/iconify';
import { useLocales } from 'src/locales';

type Props = {
  fileName: string;
  mimeType: string;
  mediaContent: string;
};

export const DownloadContentAudio = ({
  fileName,
  mimeType,
  mediaContent,
}: Props) => {
  const { translate } = useLocales();

  const { downloadFromUrl, loadingProgress } = useDownloadFromUrl({
    fileName,
    fileUrl: mediaContent,
  });

  if (!mediaContent) return null;

  return (
    <Tooltip title={translate('shared.download.download_audio_file')}>
      <StyledDownloadButton
        className="hoverShow"
        variant="outlined"
        color="inherit"
        onClick={downloadFromUrl}
      >
        {loadingProgress.loading ? (
          <CircularProgressWithLabel
            size={22}
            value={loadingProgress.progress || 1}
          />
        ) : (
          <Iconify icon="tabler:download" />
        )}
      </StyledDownloadButton>
    </Tooltip>
  );
};

const StyledDownloadButton = styled(Button)(({ theme }) => ({
  borderRadius: theme.shape.borderRadius,
  padding: theme.spacing(1),
  minWidth: 'unset',
  cursor: 'pointer',
}));
